/* eslint-disable @tanstack/query/exhaustive-deps -- they are there */
import { useQuery } from "@tanstack/react-query";

import { useAuth } from "~/providers/store/auth";

import { suppliersKeys } from "../keys";
import { getSupplier, type GetSupplierArgs } from "../requests";

export function useSupplier({
  partnerId,
  schoolId,
  ...args
}: Omit<GetSupplierArgs, "partnerId" | "schoolId"> & {
  partnerId: string | undefined | null;
  schoolId: string | undefined | null;
}) {
  return useQuery({
    queryKey: suppliersKeys.detail({
      partnerId: partnerId ?? "unknown",
      schoolId: schoolId ?? "unknown"
    }),
    queryFn: () =>
      getSupplier({
        ...args,
        partnerId: partnerId ?? "unknown",
        schoolId: schoolId ?? "unknown"
      }),
    enabled: Boolean(partnerId && schoolId)
  });
}

export function useCurrentSupplier() {
  const { partnerId, schoolId } = useAuth();

  return useSupplier({
    partnerId,
    schoolId
  });
}
